import React, { useEffect, useState } from "react";
import AdminPurchaseEntryNew from "./AdminPurchaseEntryNew";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import { a161, a164, a165, a202, a715, a730 } from "Components/Api/RootApiPath";
import { useQuery } from "@tanstack/react-query";
import { convertIntoFormData, editInvoiceValueFormat } from "utils/helpers";
import AdminInvoiceEntryNew from "./AdminInvoicEntryNew";

const AdminEditInvoiceEntryNew = () => {
  const [editStatus, setEditStatus] = useState(true);
  const [defaultData, setDefaultData] = useState();
  const [responseData, setResponseData] = useState();
  const { id } = useParams();
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates?.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const getInvoiceById = async ({ id, clientCode }) => {
    try {
      const invoiceEntry = await fetch(a730, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, clientCode }),
      });
      // const response = await fetch(a165, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     ClientCode: clientCode,
      //   }),
      // });

      const data = await invoiceEntry.json();
      // const paymentList = await response.json();
     
      const payments = data?.Payments
   
      //   const purchaseItems = await purchaseItemsResponse.json()
      //   const res = convertIntoFormData(data,purchaseItems);
      const res = editInvoiceValueFormat(data, payments);
      
      
      console.log(res);


      setDefaultData(res);
    } catch (error) {
      throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
    }
  };

  useEffect(() => {
    getInvoiceById({ id, clientCode });
  }, [id, clientCode]);

  return (
    <>
      {defaultData ? (
        <AdminInvoiceEntryNew
          editStatus={editStatus}
          defaultValues={defaultData}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AdminEditInvoiceEntryNew;
